import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { FetchUtils } from "abweb/service/utils/rpc/FetchUtils";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { StringUtils } from "abweb/utils/StringUtils";
import { ResourceBundle } from "./ResourceBundle";
export class ResourceBundleLoader {
  constructor() {
    throw new Error("Static class");
  }

  /**
   *
   * @param modName
   * @param parameterizedModPath webapp relative path with {locale} parameter for locale
   * e.g., webapp/assets/locale/{locale}/ablb.json
   * @param locales
   * @param productVersion product version, used for cache busting purposes
   * @return {Promise<ResourceBundle>}
   */
  static loadResourceBundle(modName, parameterizedModPath, locales) {
    return Promise.all(locales.map(function (locale) {
      return ResourceBundleLoader.loadBundleMap(parameterizedModPath, locale);
    }))
    // bundleMaps[] are aligned with locales[] index
    .then(function (bundleMaps) {
      const rb = new ResourceBundle(modName);
      bundleMaps.forEach(function (bundleMap, i) {
        if (bundleMap != null) {
          rb.addLocaleResources(locales[i], bundleMap);
        }
      });
      if (rb.localeBundles.length === 0) {
        // Do NOT throw as want app to be able to run app in browser (do not abort app loading workflow).
        // However, any resources subsequently looked up in the missing resource bundle will return a
        // resource value of !<resBundleName>:<resourceName>!  (e.g., '!abreacttest:about.dialog.title!')
        ResourceBundleLoader.LOG.error("Unable to load ANY resource files for resource bundle '" + modName + "'");
      }
      return rb;
    });
  }
  static loadBundleMap(parameterizedModPath, locale) {
    const fileUrl = parameterizedModPath.replaceAll(ResourceBundleLoader.LOCALE_PARAM_NAME, locale);

    // Using 'fetch' and not webpack so that they can add json files to (exploded) war and not have to rebundle
    return FetchUtils.fetchAndParseJsonFile(fileUrl).catch(err => {
      // CAT-816: suppress error msg for 'en-* bundles (hack, hack, hack) so that 'en-FR' kludge (used to get
      // en language and FR formatting (via kendo.culture.en-FR.js)) doesn't leave a trail of rb lookup errors
      if (!StringUtils.startsWith(locale, "en-")) {
        ResourceBundleLoader.LOG.error("Unable to load or parse contents of url: " + fileUrl + ".\n\tCaused by: " + err);
      }
      return null; // will cause it to NOT be added to resource bundle (but rest of processing continues)
    });
  }
}
_defineProperty(ResourceBundleLoader, "LOCALE_PARAM_NAME", "{locale}");
_defineProperty(ResourceBundleLoader, "LOG", LogUtils.getLogger(__filename));
//# sourceMappingURL=ResourceBundleLoader.js.map
